// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTermAcceptances_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /lgpd_term_acceptances
 *
 * Returns a paginated list of term acceptance records for the audit page.
 */
import type { LgpdTermAcceptances_ListRow } from './LgpdTermAcceptances_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type LgpdTermAcceptances_ListResponseDados = LgpdTermAcceptances_ListRow[];

export type LgpdTermAcceptances_ListResponse = ApiResponse<LgpdTermAcceptances_ListResponseDados>;

registerResponseContract('LgpdTermAcceptances_ListResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:             { type: 'number',  required: true },
      term_id:        { type: 'number',  required: true },
      cliente_id:     { type: 'number',  required: true },
      cliente_nome:   { type: 'string',  required: false },
      termo_titulo:   { type: 'string',  required: true },
      termo_versao:   { type: 'string',  required: true },
      termo_conteudo: { type: 'string',  required: true },
      ip_address:     { type: 'string',  required: false },
      user_agent:     { type: 'string',  required: false },
      recorded_by:    { type: 'string',  required: false },
      created_at:     { type: 'string',  required: false },
    },
  },
})
